import { LocationStrategy, isPlatformServer } from '@angular/common';
import { Component, ElementRef, Inject, PLATFORM_ID, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { switchMap, take, takeUntil } from 'rxjs/operators';
import { gameInfoTrx, missionsTrx } from 'src/app/router-translation.labels';
import { UserInfoService } from 'src/app/services/auth/check-session/user-info.service';
import { LoginStatusService } from 'src/app/services/auth/login/login-status.service';
import { LoggedStatus } from 'src/app/services/auth/login/login.models';
import { DetectDeviceService } from 'src/app/services/utils/detect-device.service';
import { BalanceService } from 'src/app/services/wallet/balance.service';
import { BalanceInAppInfo } from 'src/app/services/wallet/wallet.models';
import { TranslationConfig } from 'src/app/utils/translate-config';
import { SwiperOptions } from 'swiper';
import { BasePageComponent, BasePageComponentWithDialogs } from '../../base-page/base-page.component';
import { DESKTOP_FULL_HEIGHT, DialogConfig, FULL_DIALOG_CONFIG } from '../../dialog/dialog.config';
import { MissionService } from 'src/app/services/missions/mission.service';
import { MISSIONTYPE, Mission } from 'src/app/services/missions/missions.models';
import { LicenceService } from 'src/app/services/utils/licence.service';
import { ActivePrizesComponent } from '../../client-area/active-prizes/active-prizes.component';
import { BalanceStatusService } from 'src/app/services/wallet/balance-status.service';

const confirmationMsg: string = $localize`:@@tournamentRebuyBonusConfirmationMsg:Are you sure you want to rebuy mission's bonus?`;

@Component({
  template: ''
})
export class MainMissionRouteComponent extends BasePageComponent {

  constructor(public missionDialog: MatDialog,
    public router: Router,
    public route: ActivatedRoute,
    public missionService: MissionService,
    public detectDesktopService: DetectDeviceService,
    @Inject(PLATFORM_ID) public platformId,
  ) {
    super()
  }

  dialogSize: DialogConfig = FULL_DIALOG_CONFIG;
  isInGame: boolean = false;



  ngOnInit(): void {
    console.log('mission popup component')
    if (!isPlatformServer(this.platformId)) {

      const param = this.route.snapshot.queryParamMap;
      this.isInGame = param.get('isInGame') === '1'

      if (this.detectDesktopService.isDesktop()) {
        this.dialogSize = DESKTOP_FULL_HEIGHT;
        this.isDesktop = true;
      }

      this.route.params
        .pipe(
          switchMap((params) => {
            const tournamentIndex = params['id'];
            return this.missionService.getMission(tournamentIndex);
          }
          ),
          take(1))

        .subscribe((mission: Mission) => {
          console.log('mission popup opened')
          this.openDialog(mission, this.isInGame);
        })
    }

  }

  openDialog(mission: Mission, isInGame: boolean): void {
    const dialogRef = this.missionDialog.open(MainMissionComponent, {
      ...this.dialogSize,
      panelClass: 'tournaments-dialog',
      data: { mission: mission, isInGame: isInGame }
    });
    // dialogRef.afterClosed().subscribe((quit: boolean) => {
    //   if (quit) this.router.navigate(["/missions"], { relativeTo: this.route })
    //   else this.router.navigate(["/"], { relativeTo: this.route })
    // });
    dialogRef.afterClosed().subscribe((resp: { quit: boolean, redirectUrl: string[] }) => {
      console.log(resp?.redirectUrl)
      if (this.isInGame) return;
      else this.router.navigate(!!resp?.redirectUrl ? resp?.redirectUrl : ["../../../"], { relativeTo: this.route })
    });
  }
}

@Component({
  selector: 'app-main-mission',
  templateUrl: './main-mission.component.html',
  styleUrls: ['./main-mission.component.scss']
})
export class MainMissionComponent extends BasePageComponentWithDialogs {

  tabIndex: number = 0;
  private localStorageKey: string = '';
  missionsTrx: string = missionsTrx;

  constructor(
    public dialogRef: MatDialogRef<MainMissionComponent>,
    protected translationConfig: TranslationConfig,
    public loginStatusService: LoginStatusService,
    public balanceService: BalanceStatusService,
    public router: Router,
    public route: ActivatedRoute,
    public detectDesktopService: DetectDeviceService,
    public userInfoService: UserInfoService,
    dialog: MatDialog,
    public missionService: MissionService,

    @Inject(MAT_DIALOG_DATA) public dialogData: { mission: Mission, isInGame, boolean },
    protected licenceService: LicenceService

  ) { super(dialog, detectDesktopService) }

  clicked = 1;
  isLogin: boolean;
  availableRebuys: number;
  tournamentRebuyAddPoints: number
  rebuysUsed = 0;
  currency: string;
  rebuyPrice: number;
  balance$: Observable<BalanceInAppInfo>;
  isSumbitRebuyAllowed: boolean = true;
  isActive: boolean = false;
  mission: Mission;
  previousURL: string = '/';

  public config: SwiperOptions = {
    direction: 'horizontal',
    slideToClickedSlide: false,
    mousewheel: true,
    scrollbar: false,
    navigation: false,
    keyboard: true,
    freeMode: true,
    slidesPerView: 3.7,
    centerInsufficientSlides: false,
    centeredSlides: false,
    loop: false,
    simulateTouch: true,
    roundLengths: true,
    spaceBetween: 16
  };

  initialaze(mission: Mission) {
    this.balance$ = this.balanceService.getBalanceInfoStatus().pipe(takeUntil(this.unsubscribe));
    this.mission = mission;
    this.loginStatusService.getLoginStatus()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(resp => {
        this.isLogin = resp.isLogged === LoggedStatus.logged;
        if (this.isLogin) {
          this.currency = resp.currency;
        }
      })
    this.userInfoService.disableChat();
    this.isActive = mission.missionType === MISSIONTYPE.ACTIVE;
    this.tabIndex = this.missionService.getMissionTab(this.mission.cmsId);
  }

  ngOnInit(): void {
    this.previousURL = this.route.snapshot.queryParamMap.get('ref')

    console.log(this.previousURL)
    this.clicked = this.dialogData.mission?.missionType === MISSIONTYPE.UPCOMMING ? 0 : 1;
    this.initialaze(this.dialogData.mission);
  }



  closeDialog(redirectUrl?: string[]) {
    console.log(redirectUrl)
    if (this.previousURL) {
      this.dialogRef?.close({ quit: false, redirectUrl: [`/${this.previousURL}`] })
    } else if (!!redirectUrl) {
      this.dialogRef?.close({ quit: false, redirectUrl: redirectUrl })
    }
    else {
      this.dialogRef?.close();
    }
  }

  launchGame(gameId, gameName) {
    this.previousURL = null;
    if (this.detectDesktopService.isDesktop()) {
      this.router.navigate(["", this.translationConfig.getTranslation(gameInfoTrx), ActivePrizesComponent.mapGameName(gameName)]).then(() => {
        this.closeDialog();
      });

    }
    else {
      this.closeDialog(['', this.translationConfig.getTranslation(gameInfoTrx), ActivePrizesComponent.mapGameName(gameName)]);
      // this.router.navigate(['', this.translationConfig.getTranslation(gameInfoTrx), gameName]).then(() => {
      //   this.userInfoService.openChat();
      // });
    }
    // this.router.navigate(['/'+launcgGameTrx+'/'+this.data.gameid]);
  }

  onTabChange(event: MatTabChangeEvent) {
    this.missionService.saveMissionTab(this.mission.cmsId, event.index);
  }

}
